// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"c580f181","453":"571f855e","511":"e23bfadb","574":"2b4b8aa7","617":"eff81160","663":"a9e1010c","720":"c292409a","796":"99e02400"}[chunkId] + ".chunk.js";
};